import { closeToast, showLoadingToast } from 'vant'

class Loading {
  private toast

  constructor() {
    this.toast = null
  }

  public loading(message = '') {
    this.toast = showLoadingToast({
      message: message,
      duration: 0, // 持续展示 toast
      forbidClick: true, // 禁用背景点击
      overlay: true,
      type: 'loading', //默认 circular
    })
  }

  public close() {
    closeToast()
  }
}

const Spinner = new Loading()

export default Spinner
